export enum SurveyEditorMode {
  Design = 'design',
  Preview = 'preview',
  Share = 'share',
}
